export default {
    book: 'Rezervuoti {product}',
    age_limit: 'Tik virš {age} m. amžiaus',
    change_plan: "Keisti planą",
    upgrade_product: 'Naujinti produktą',
    upgrade: "Patobulinti",
    cancel_upgrade: "Atšaukti atnaujinimą",
    choose_product: 'Pasirinkti {product}',
    days: '{count} diena | {count} dienos',
    login_register: "Prisijunk/užsiregistruok",
    current: "Dabartinė",
    keyless_benefits: {
        label: 'Tiesiai į automobilį {0}',
        highlight: 'nuomos paslauga™',
        list: {
            cant_lose_the_key: 'Visas draudimas',
            zero_excess: 'Nulis pertekliaus',
            phone_as_a_key: 'Telefonas kaip raktas',
            straight_to_car: 'Jokio laukimo',
            no_queues: 'Jokių eilių',
            online_id_check: 'Internetinis tapatybė čekis',
            self_checkout: 'Savitarnos kasa',
        },
    },
}
